import React, { useImperativeHandle, forwardRef, useState,useEffect } from "react";

// Componente hijo (con la función "hacer")
const ZoomImage = forwardRef((props, ref) => {

    // Estado para controlar si la imagen está en pantalla completa
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [fullscreenImage, setFullscreenImage] = useState("");
    const [zoomClass, setZoomClass] = useState("");

    // Función para abrir la imagen a pantalla completa
    const openFullscreen = (src) => {
        setFullscreenImage(src);
        setIsFullscreen(true);
    };

    // Función para cerrar la imagen a pantalla completa
    const closeFullscreen = () => {
        setIsFullscreen(false);
    };

    useImperativeHandle(ref, () => ({
        openFullscreen,
      }));

    // Usamos useEffect para añadir la clase de zoom una vez la imagen esté renderizada
    useEffect(() => {
        if (isFullscreen) {
            setTimeout(() => {
                setZoomClass("zoom-in");
            }, 100);
        } else {
            setTimeout(() => {
                setZoomClass("");
            }, 100);
        }
    }, [isFullscreen]);

    return (

        <div>
            {/* Imagen en pantalla completa */}
            {isFullscreen && (
                <div className="fullscreen-img" onClick={closeFullscreen}>
                    <img
                        src={fullscreenImage}
                        alt="Imagen a pantalla completa"
                        className={`fullscreen-img-content ${zoomClass}`}
                    />
                </div>
            )}
        </div>
    );
});

export default ZoomImage;